import axios from "axios";
import { Master_Service_URL } from "../Url";

export const searchIifscDetailsActions = {
  SEARCH_IIFSC_LOADING: "SEARCH_IIFSC_LOADING",
  SEARCH_IIFSC_SUCCESS: "SEARCH_IIFSC_SUCCESS",
  SEARCH_IIFSC_ERROR: "SEARCH_IIFSC_ERROR",
};

export const searchIifscDetails = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { ifsc } = props;

  dispatch(searchIifscLoading());
  return axios({
    method: "post",
    url: `${Master_Service_URL}/search/BankBranch/ByIfsc?ifsc=${ifsc}`,
    headers: {
      authorization: "Bearer " + accessToken,
    },

  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(searchIifscSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);
        dispatch(searchIifscError(error));
        throw error;
      }
    })
    .catch((err) => {
      if (err.response) {
        dispatch(searchIifscError(err));
        return err.response;
      }
    });
};

export function searchIifscError(error) {
  return {
    type: searchIifscDetailsActions.SEARCH_IIFSC_ERROR,
    payload: error,
  };
}

export function searchIifscSuccess(props) {
  return {
    type: searchIifscDetailsActions.SEARCH_IIFSC_SUCCESS,
    payload: props,
  };
}

export function searchIifscLoading() {
  return {
    type: searchIifscDetailsActions.SEARCH_IIFSC_LOADING,
  };
}

export const searchBranchDetailsActions = {
  SEARCH_BRANCH_DETAILS_LOADING: "SEARCH_BRANCH_DETAILS_LOADING",
  SEARCH_BRANCH_DETAILS_SUCCESS: "SEARCH_BRANCH_DETAILS_SUCCESS",
  SEARCH_BRANCH_DETAILS_ERROR: "SEARCH_BRANCH_DETAILS_ERROR",
};

export const searchBranchDetails = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { params } = props;

  dispatch(searchBranchDetailsLoading());
  return axios({
    method: "post",
    url: `${Master_Service_URL}/search/BankBranch`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
    params: params,
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(searchBranchDetailsSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);
        dispatch(searchBranchDetailsError(error));
        throw error;
      }
    })
    .catch((err) => {
      if (err.response) {
        dispatch(searchBranchDetailsError(err));
        return err.response;
      }
    });
};

export function searchBranchDetailsError(error) {
  return {
    type: searchBranchDetailsActions.SEARCH_BRANCH_DETAILS_ERROR,
    payload: error,
  };
}

export function searchBranchDetailsSuccess(props) {
  return {
    type: searchBranchDetailsActions.SEARCH_BRANCH_DETAILS_SUCCESS,
    payload: props,
  };
}

export function searchBranchDetailsLoading() {
  return {
    type: searchBranchDetailsActions.SEARCH_BRANCH_DETAILS_LOADING,
  };
}
